import React, { useMemo } from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, Grid, Card, CardContent } from '@mui/material';

export default function ProcessIndicators({ data }) {
  const indicatorData = useMemo(() => {
    if (!data || Object.keys(data).length === 0) {
      return [];
    }
    return [
      { label: 'Evaluaciones Iniciadas', value: data.evaluaciones_iniciadas || 0 },
      { label: 'Evaluaciones Completadas', value: data.evaluaciones_completadas || 0 },
      { label: 'Tasa de Completitud', value: `${((data.evaluaciones_completadas || 0) / (data.evaluaciones_iniciadas || 1) * 100).toFixed(2)}%` || '0.00%' },
      { label: 'Evaluaciones con Comentarios DM', value: data.evaluaciones_con_comentarios_dm || 0 },
      { label: 'Evaluaciones Calibradas', value: data.evaluaciones_calibradas || 0 },
    ];
  }, [data]);

  if (!data || Object.keys(data).length === 0) {
    return (
      <Paper elevation={3} sx={{ p: 3, borderRadius: '12px', textAlign: 'center' }}>
        <Typography variant="subtitle1">No hay datos de indicadores de proceso disponibles para el período seleccionado.</Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: '12px' }}>
      <Grid container spacing={2}>
        {indicatorData.map((indicator, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ borderRadius: '12px', boxShadow: 1 }}>
              <CardContent>
                <Typography color="text.secondary" gutterBottom sx={{ fontSize: '0.875rem' }}>
                  {indicator.label}
                </Typography>
                <Typography variant="h5" component="div" sx={{ fontSize: '1.75rem', fontWeight: 'bold' }}>
                  {indicator.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
} 